import type { PropsWithChildren } from 'react'
import type { FAIconProps } from './fa-icon'
import { FAIcon } from './fa-icon'
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip'
import { useTooltipTap } from './use-tooltip-tap'
import { ZIndexRange } from '@/types/style'

interface Props extends PropsWithChildren {
  triggerClassName?: string
  contentClassName?: string

  icon?: FAIconProps['icon'] | FAIconProps
  side?: 'top' | 'right' | 'bottom' | 'left'
}

export function IconTooltip({
  children,

  triggerClassName,
  contentClassName,

  icon = { icon: 'info-circle', type: 'regular' },
  side,
}: Props) {
  const iconProps: FAIconProps = typeof icon === 'object' ? icon : { icon }
  const { rootProps, triggerProps, contentProps } = useTooltipTap()

  return (
    <Tooltip {...rootProps}>
      <TooltipTrigger
        {...triggerProps}
        className={triggerClassName}
        type="button"
      >
        <FAIcon {...iconProps} />
      </TooltipTrigger>

      <TooltipContent
        {...contentProps}
        className={contentClassName}
        side={side}
        style={{ zIndex: ZIndexRange.Extra }}
      >
        {children}
      </TooltipContent>
    </Tooltip>
  )
}
